
import { defineComponent, ref, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// date time picker
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import CKEditor from "@ckeditor/ckeditor5-vue";
import { Field } from "vee-validate";
import { Invoice, Platform, Sensor, Shipment } from "./invoice";
import {
  getCustomersList,
  createInvoice,
  getInvoice,
  updateInvoice,
} from "@/store/api/devices";
import moment from "moment";
import router from "@/router";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "invoice",
  components: {
    Datepicker,
    Field,
    ckeditor: CKEditor.component,
  },
  setup() {
    const route = useRoute();
    const editor = ClassicEditor;
    const action = ref<string>("Save");
    const invoice = ref<Invoice>({
      sensor: { vat: 0, discount: 0, percentage: 100 } as Sensor,
      platform: { vat: 0, discount: 0, percentage: 100 } as Platform,
      shipment: { vat: 0, discount: 0, percentage: 100 } as Shipment,
      sensorList: [] as Sensor[],
      platformList: [] as Platform[],
      shipmentList: [] as Shipment[],
      content: `<p><strong>Terms &amp; Conditions:</strong></p><ol><li>&nbsp;Device price is Ex-Works China.&nbsp;</li><li>&nbsp;Prices are net prices in EURO, and do not include sales taxes, withholding taxes, levies, duties or Banking Charges.&nbsp;</li><li>&nbsp;Price terms as defined in ICC INCOTERMS 2010.&nbsp;</li><li>&nbsp;Delivery date will be confirmed, once the PO is acknowledged and production plan is checked by SmartEnds.&nbsp;</li><li>&nbsp;If customer wants to arrange a pick up from our factory in China using its own freight forwarder, then Necessary support will be provided by SmartEnds; If customer wants SmartEnds to arrange the transport and shipment with DDP Incoterm to customer premises directly, then SmartEnds will use their own freight forwarder, and the cost of shipment from the factory in China to the customer premises will be transparently invoiced.&nbsp;</li><li>&nbsp;Hardware prices include one (1) year warranty from delivery date (Repair ‘n’ Return, Product Guidance 5x8 and Software Update services).&nbsp;</li><li>&nbsp;If the hardware is DOA (dead on arrival), SmartEnds will cover the shipment cost of both side. SmartEnds will pick up from the customer site and deliver replacement units on the customer site at its own costs.&nbsp;</li><li>&nbsp;If the warranty of a device is claimed by a customer which requires repair and replacement, then Customer at its own cost will ship the device or devices to the location provided by Smartends and Smartends at its own cost will repair and / or replace the faulty unit and ship it to the customer location.&nbsp;</li><li>&nbsp;POs are irrevocable and non-cancellable.&nbsp;</li><li>&nbsp;The IoT Network Connectivity cost is not included in the offer.&nbsp;</li><li>The Quotation does not include any installation costs for installing the sensors at site. This will be discussed and quoted separately.&nbsp;</li><li>&nbsp;The monitoring platform invoices will be issued at the beginning of the Project on the placement of the PO for one year from the date of connectivity. Payment of each invoice is invoice issuance plus 7 days.</li></ol><p>&nbsp;</p><p><strong>These general conditions of sale are applicable to any order placed by the buyer with the seller and to all its sales contracts, including all ancillary services.</strong></p><p>,</p>`,
      invoice_date: new Date(),
      due_date: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() + 7
      ),
      delivery_date: new Date(),
      currency: "",
      po_number: "",
      se_account_id: "0",
      price: 0,
    });
    const subTotal: any = [];
    const customers = ref<any[]>([]);
    let comm_number: any = "";
    onMounted(() => {
      setCurrentPageBreadcrumbs("Create Invoice", [""]);
      // setCommunicationNumber();
      route.params.id ? loadInvoice() : false;
      getCustomersList().then((response) => {
        customers.value = response;
      });
    });

    const loadInvoice = () => {
      getInvoice(route.params.id).then((res) => {
        // invoice.value = res;

        let parsedJson = JSON.parse(res.json);
        invoice.value.shipmentList = parsedJson.shipmentList;
        invoice.value.platformList = parsedJson.platformList;
        invoice.value.sensorList = parsedJson.sensorList;
        // invoice.value.sensor = {};
        // invoice.value = res;
        invoice.value.se_account_id = res.se_account_id;
        invoice.value.po_number = res.po_number;
        invoice.value.currency = res.currency;
        invoice.value.price = res.price;
        invoice.value.content = res.content;
        invoice.value.due_date = new Date(res.due_date);
        invoice.value.invoice_date = new Date(res.invoice_date);
        invoice.value.delivery_date = new Date(res.delivery_date);
        action.value = "Update";
      });
    };

    const onSubmit = (section?: any) => {
      let list = section + "List";
      invoice.value[section]["id"] = invoice.value[list].length + 1;
      parseFloat(invoice.value[section].total_price);
      invoice.value[list].push(invoice.value[section]);
      invoice.value.price = 0;

      if (section == "sensor") {
        addSensor();
        invoice.value.sensor = {
          vat: 0,
          percentage: 100,
        } as Sensor;
      } else if (section == "platform") {
        addPlatform();
        invoice.value.platform = {
          vat: 0,
          percentage: 100,
        } as Platform;
      } else {
        addShipment();
        invoice.value.shipment = {
          vat: 0,
          percentage: 100,
        } as Shipment;
      }
      getTotoal();
    };

    const addSensor = () => {
      invoice.value.sensor.total_price = parseFloat(
        (
          invoice.value.sensor.quantity * invoice.value.sensor.unit_price
        ).toFixed(2)
      );
      invoice.value.sensor.payable_now = percentage(
        invoice.value.sensor.percentage,
        invoice.value.sensor.total_price
      );
      let payable = percentage(
        invoice.value.sensor.vat,
        invoice.value.sensor.payable_now
      );
      invoice.value.sensor.total_incl_vat = parseFloat(
        (invoice.value.sensor.payable_now + payable).toFixed(2)
      );
    };

    const addPlatform = () => {
      invoice.value.platform.total_price = parseFloat(
        (
          invoice.value.platform.total_sensor *
          invoice.value.platform.charges_per_month *
          invoice.value.platform.no_of_months
        ).toFixed(2)
      );
      invoice.value.platform.payable_now = percentage(
        invoice.value.platform.percentage,
        invoice.value.platform.total_price
      );
      let payable = percentage(
        invoice.value.platform.vat,
        invoice.value.platform.payable_now
      );
      invoice.value.platform.total_incl_vat = parseFloat(
        (invoice.value.platform.payable_now + payable).toFixed(2)
      );
    };

    const addShipment = () => {
      invoice.value.shipment.total_price = invoice.value.shipment.shipment_cost;
      invoice.value.shipment.payable_now = percentage(
        invoice.value.shipment.percentage,
        invoice.value.shipment.total_price
      );
      let payable = percentage(
        invoice.value.shipment.vat,
        invoice.value.shipment.payable_now
      );
      invoice.value.shipment.total_incl_vat = parseFloat(
        (invoice.value.shipment.payable_now + payable).toFixed(2)
      );
    };

    const getTotoal = () => {
      let total = subTotal.concat(
        invoice.value.sensorList,
        invoice.value.platformList,
        invoice.value.shipmentList
      );
      total.forEach((element) => {
        invoice.value.price += parseFloat(element.total_incl_vat);
      });
      let toFixed = invoice.value.price?.toFixed(2);
      return toFixed;
    };

    const removeItem = (item: any, seciton) => {
      invoice.value[seciton].splice(
        invoice.value[seciton].findIndex((x) => x.id == item.id),
        1
      );
      invoice.value.price = 0;
      getTotoal();
    };

    const save = () => {
      if (action.value == "Update") {
        invoice.value["id"] = route.params.id;
        updateInvoice(invoice.value).then(() => {
          router.push("/apps/billing/invoice");
        });
      } else {
        createInvoice(invoice.value).then(() => {
          router.push("/apps/billing/invoice");
        });
      }
    };

    const onCustomerChange = (event) => {
      invoice.value.se_account_id = event.target.value;
      // invoice.value.se_account_id = parseInt(invoice.value.se_account_id);
    };

    return {
      editor,
      invoice,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
      },
      onSubmit,
      removeItem,
      save,
      customers,
      onCustomerChange,
      action,
    };
  },
});
function percentage(percent, total) {
  (total = parseFloat(total)), (percent = parseFloat(percent));
  let result = (percent / 100) * total;
  return result;
}
